import { Component, OnInit } from '@angular/core';
import { AppInfoService } from 'core/app-info/app-info.service';
import { AppStateService } from 'core/app-state/app-state.service';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { Icon } from '../icon/icon.enum';
import { AppLocalization } from '../entities/app-localization';

@Component({
  selector: 'app-offline-no-internet-connection-required',
  templateUrl: './offline-no-internet-connection.component.html',
  styleUrls: ['./offline-no-internet-connection.component.scss'],
  standalone: false
})
export class OfflineNoInternetConnectionComponent implements OnInit {
  appStrings: AppLocalization;
  appIcon: string;
  offlineIcon: string;

  private offlineConnectionReqSize = {
    width: '99vw',
    height: '90vh'
  };

  constructor(
    private appInfoService: AppInfoService,
    private appStateService: AppStateService,
    public dialogRef: MatDialogRef<OfflineNoInternetConnectionComponent>,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.appStrings = this.appInfoService.appStrings;
    this.appIcon = Icon.logo;
    this.offlineIcon = Icon.offline;
  }

  /**
   * Handles the retry action from the button
   */
  retry() {
    if (!this.appStateService.state.isInternetConnected) {
      return;
    }
    this.appStateService.goOnline().subscribe(() => {
      // This is intentional
    }, () => this.displayNoInternetConnectionModal());
    this.dialogRef.close();
  }

  displayNoInternetConnectionModal() {
    this.dialog.open(OfflineNoInternetConnectionComponent, {
      disableClose: true,
      width: this.offlineConnectionReqSize.width,
      height: this.offlineConnectionReqSize.height,
      maxWidth: this.offlineConnectionReqSize.width
    });
  }

}
